import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, PageEvent, MatPaginator, MatDialog } from '@angular/material';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ComponentPageTitle } from 'src/app/page-title/page-title.component';
import { AppServiceService } from 'src/app/services/app-service.service';
import { BusquedaService } from '../busqueda.service';
import { CreateService } from '../createservice';
import { GatewayService } from 'src/app/gateway.service';
import { FiltroPaisService } from '../filtro-pais.service';
import { LocalSaveService } from 'src/app/services/local-save-service.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatSnackBar } from '@angular/material';
import { FormGroup, FormControl } from '@angular/forms';
import { VerCertificadoDialogComponent } from './ver-certificado-dialog/ver-certificado-dialog.component';
import { DescargarLotesComponent } from 'src/app/home/descargar-lotes/descargar-lotes.component';
import { ConfirmacionComponent } from 'src/app/home/confirmacion/confirmacion.component';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-historialcertificado',
  templateUrl: './historialcertificado.component.html',
  styleUrls: ['./historialcertificado.component.scss']
})
export class HistorialcertificadoComponent implements OnInit {
  private destroy$ = new Subject<void>();
  minDate = new Date();
  maxDate = new Date();

  grupoVal = new FormGroup({
    FECHA_EJECUCION: new FormControl(''),
    ORDEN: new FormControl(''),
    IDUSER: new FormControl(''),
    EQUIPO: new FormControl(''),
    TIPO: new FormControl(''),
    STATUS: new FormControl(''),
  });

  // Opciones de los filtros de tipo y status (espejo del mapeo del backend:
  // TIPO 1=HFC, 2=FTTH, 3=TV, 4=TELEFONIA; STATUS 1=VALIDO, 0=INVALIDO).
  tiposEquipo = [
    { value: 1, label: 'HFC' },
    { value: 2, label: 'FTTH' },
    { value: 3, label: 'TV' },
    { value: 4, label: 'TELEFONIA' },
  ];
  estadosCertificado = [
    { value: 1, label: 'VALIDO' },
    { value: 0, label: 'INVALIDO' },
  ];

  // Autorefresh: cada 60s, inicia encendido, respeta los filtros actuales
  // (reusa get() que lee los valores del formulario).
  public autoRefresh = true;
  private readonly REFRESH_MS = 60000;
  private refreshIntervalId: any = null;

  tableColumns: string[] = ['ID', 'EQUIPO', 'TIPO', 'IDUSER', 'NOMBRE_USUARIO', 'TIPO_USER', 'FECHA_EJECUCION', 'ID_CITA', 'ORDEN', 'STATUS_CERTIFICADO', 'ACCIONES'];
  dataSource = new MatTableDataSource<any>([]);
  private subscriptioncreate: Subscription;
  private subscriptionpais: Subscription;
  FILTER: string = '';
  resultsLength = 0;
  pageSize = 10;
  idpais: any;
  pageEvent: PageEvent;
  public actpage: number = 0;
  public listaUsuarios: any[] = [];
  @ViewChild('paginatortable') paginatortable: MatPaginator;

  constructor(
    private spinner: NgxSpinnerService,
    private gateway: GatewayService,
    public pageTitle: ComponentPageTitle,
    public _appservice: AppServiceService,
    public _busqueda: BusquedaService,
    public _create: CreateService,
    private dialog: MatDialog,
    public _filtroPais: FiltroPaisService,
    private localSave: LocalSaveService,
    private snackbar: MatSnackBar,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.idpais = this.localSave.get('pais');
    
    const usuario = this.localSave.get('usuarioPGV');
    if (usuario) {
      const idrol = usuario.idrol || usuario.IDROL;
      if (idrol == 17) {
        this.pageSize = 6;
      } else if (idrol == 25) {
        this.pageSize = 10;
      } else {
        this.pageSize = 10;
      }
    }
    
    this.cargarUsuarios();
    
    this.get(0);
    // Solo setear el título cuando se accede como vista independiente (ruta propia),
    // no cuando está embebido como tab dentro de la botonera
    if (this.route.snapshot.routeConfig && this.route.snapshot.routeConfig.path === 'historialcertificado') {
      this.pageTitle.title = 'Historial de Certificados';
    }
    
    this.subscriptioncreate = this._create.notifyObservable$.pipe(takeUntil(this.destroy$)).subscribe(
      res => {
      });
    this.subscriptionpais = this._filtroPais.notifyObservable$.pipe(takeUntil(this.destroy$)).subscribe(
      res => {
        this.idpais = res.IDPAIS;
        this.get(0);
      }
    );

    // Inicia el autorefresh encendido por defecto.
    this.iniciarAutoRefresh();
  }

  // Arranca el ciclo de autorefresh (cada REFRESH_MS). El refresco silencioso
  // (sin spinner) recarga la pagina actual respetando los filtros vigentes.
  private iniciarAutoRefresh() {
    this.detenerAutoRefresh();
    this.refreshIntervalId = setInterval(() => {
      this.get(this.actpage, true);
    }, this.REFRESH_MS);
  }

  private detenerAutoRefresh() {
    if (this.refreshIntervalId) {
      clearInterval(this.refreshIntervalId);
      this.refreshIntervalId = null;
    }
  }

  // Toggle del slide del template: enciende/apaga el autorefresh.
  public toggleAutoRefresh(activo: boolean) {
    this.autoRefresh = activo;
    if (activo) {
      this.iniciarAutoRefresh();
    } else {
      this.detenerAutoRefresh();
    }
  }

  public filtrogeneral() {
    if (this.paginatortable) {
      this.paginatortable.firstPage();
    }
    // Reseteamos actpage para que el autorefresh recargue la pagina 0 (la que
    // queda visible tras buscar), no la pagina previa.
    this.actpage = 0;
    this.get(0);
  }

  public descargar() {
    const fechaEjecucion = this.formatDateToYYYYMMDD(this.grupoVal.controls.FECHA_EJECUCION.value);

    const dialogRef = this.dialog.open(DescargarLotesComponent, {
      disableClose: true,
      width: '700px',
      data: {
        cantPorPagina: 1000,
        nombreServicioCantRegistros: 'getContHistorialCertificado',
        nombreServicioRegistros: 'descargarHistorialCertificado',
        nombreArchivo: `historial_certificados_${new Date().toISOString().slice(0, 10).replace(/-/g, '')}.xlsx`,
        params: {
          FECHA_EJECUCION: fechaEjecucion,
          ORDEN: this.grupoVal.controls.ORDEN.value || '',
          IDUSER: this.grupoVal.controls.IDUSER.value || '',
          EQUIPO: this.grupoVal.controls.EQUIPO.value || '',
          TIPO: this.grupoVal.controls.TIPO.value || '',
          STATUS: this.grupoVal.controls.STATUS.value === '' || this.grupoVal.controls.STATUS.value === null ? '' : this.grupoVal.controls.STATUS.value
        }
      }
    });

    dialogRef.afterClosed().subscribe((resp) => {
    });
  }

  cargarUsuarios() {
    this.gateway.get('getUsuariosCertificado', {}).then((result: any) => {
      this.listaUsuarios = (result.rows || []).filter(usuario => 
        usuario.NOMBRE_USUARIO && 
        usuario.NOMBRE_USUARIO.trim() !== ''
      );
    }).catch((e) => {
      this.listaUsuarios = [];
    });
  }

  private formatDateToYYYYMMDD(date: any): string {
    if (!date) {
      return '';
    }
    const d = new Date(date);
    if (isNaN(d.getTime())) {
      return '';
    }
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  // silent=true (usado por el autorefresh) recarga sin mostrar el spinner global,
  // para no parpadear la pantalla cada 60s.
  get(page, silent: boolean = false) {
    if (!silent) { this.spinner.show(); }
    const fechaEjecucion = this.formatDateToYYYYMMDD(this.grupoVal.controls.FECHA_EJECUCION.value);

    const filtros = {
      NUM_ELEMENTOS: this.pageSize,
      NUM_PAGINA: page,
      FECHA_EJECUCION: fechaEjecucion,
      ORDEN: this.grupoVal.controls.ORDEN.value || '',
      IDUSER: this.grupoVal.controls.IDUSER.value || '',
      EQUIPO: this.grupoVal.controls.EQUIPO.value || '',
      TIPO: this.grupoVal.controls.TIPO.value || '',
      STATUS: this.grupoVal.controls.STATUS.value === '' || this.grupoVal.controls.STATUS.value === null ? '' : this.grupoVal.controls.STATUS.value
    };

    this.gateway.get('getHistorialCertificado', filtros).then((result) => {
        let aux: any = result;
        let rows = aux.rows || [];

        this.dataSource = new MatTableDataSource<any>(rows);

        this.gateway.get('getContHistorialCertificado', filtros).then((result: any) => {
          this.resultsLength = result.rows && result.rows.length > 0 ? result.rows[0].total : 0;
          if (!silent) { this.spinner.hide(); }
        }).catch((e) => {
          this.resultsLength = 0;
          if (!silent) { this.spinner.hide(); }
        });
      }
      ).catch((e) => {
        this.dataSource = new MatTableDataSource<any>([]);
        this.resultsLength = 0;
        if (!silent) { this.spinner.hide(); }
      });
  }

  cambioElementos(event?: PageEvent) {
    this.actpage = event.pageIndex;
    this.get(event.pageIndex);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.detenerAutoRefresh();
    if (this.subscriptioncreate) {
      this.subscriptioncreate.unsubscribe();
    }
    if (this.subscriptionpais) {
      this.subscriptionpais.unsubscribe();
    }
  }

  copyToClipboard(data: any) {
    let jsonString: string;
    
    try {
      if (typeof data === 'string') {
        const parsed = JSON.parse(data);
        jsonString = JSON.stringify(parsed, null, 2);
      } else {
        jsonString = JSON.stringify(data, null, 2);
      }
    } catch (e) {
      jsonString = typeof data === 'string' ? data : JSON.stringify(data);
    }
    
    const textArea = document.createElement('textarea');
    textArea.value = jsonString;
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    textArea.style.top = '-999999px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    
    try {
      document.execCommand('copy');
      this.snackbar.open('JSON copiado al portapapeles', 'Cerrar', {
        duration: 2000,
        horizontalPosition: 'center',
        verticalPosition: 'bottom'
      });
    } catch (err) {
      this.snackbar.open('Error al copiar al portapapeles', 'Cerrar', {
        duration: 2000
      });
    } finally {
      document.body.removeChild(textArea);
    }
  }

  getFormattedJson(data: any): string {
    try {
      if (typeof data === 'string') {
        const parsed = JSON.parse(data);
        return JSON.stringify(parsed, null, 2);
      }
      return JSON.stringify(data, null, 2);
    } catch (e) {
      return typeof data === 'string' ? data : JSON.stringify(data);
    }
  }

  getJsonPreview(data: any): string {
    try {
      const jsonString = typeof data === 'string' ? data : JSON.stringify(data);
      return jsonString.length > 50 ? jsonString.substring(0, 50) + '...' : jsonString;
    } catch (e) {
      return 'Error al formatear JSON';
    }
  }

  verCertificado(element: any) {
    this.dialog.open(VerCertificadoDialogComponent, {
      width: '800px',
      maxWidth: '90vw',
      data: element
    });
  }

  aprobarCertificado(element: any) {
    if (!element || !element.ID) {
      this.snackbar.open('No se puede aprobar: registro inválido.', 'Cerrar', { duration: 3000 });
      return;
    }

    // Dialog de confirmación reutilizando ConfirmacionComponent
    // (muestra "¿Seguro que desea {msj}?")
    const ref = this.dialog.open(ConfirmacionComponent, {
      disableClose: true,
      width: '420px',
      data: {
        msj: 'aprobar el certificado del equipo ' + (element.EQUIPO || '')
      }
    });

    ref.afterClosed().subscribe((res: any) => {
      if (!res || !res.resp) { return; }
      this.spinner.show();
      this.gateway.get('aprobarCertificado', { ID: element.ID })
        .then((result: any) => {
          this.spinner.hide();
          if (result && result.response === 1 && result.affectedRows > 0) {
            this.snackbar.open('Certificado aprobado correctamente.', 'Cerrar', { duration: 3000 });
            // Refrescar la página actual de la tabla
            this.get(this.actpage);
          } else {
            this.snackbar.open('No se pudo aprobar el certificado.', 'Cerrar', { duration: 4000 });
          }
        })
        .catch(() => {
          this.spinner.hide();
          this.snackbar.open('Error al aprobar el certificado.', 'Cerrar', { duration: 4000 });
        });
    });
  }
}
